/* eslint-disable import/prefer-default-export */
import { createIntl } from 'react-intl';
import fetch from '../core/fetch';
import {
  SET_LOCALE_START,
  SET_LOCALE_SUCCESS,
  SET_LOCALE_ERROR,
} from '../constants';
import getDynamicListSettings from './GetDynamicListSettings/getDynamicListSettings';
import { dateInternationalization, formatLocaleData } from '../helpers/formatLocale';
import getDynamicListTitles from './GetDynamicListSettings/getDynamicListTitle';

//import queryIntl from './intl.graphql';

function getIntlFromState(state) {
  const intl = (state && state.intl) || {};
  const { initialNow, locale, messages } = intl;
  const localeMessages = (messages && messages[locale]) || {};

  const intlProvider = createIntl({
    initialNow,
    locale,
    messages: localeMessages,
    defaultLocale: 'en',
  });

  return intlProvider;

}

export function getIntl() {
  return (dispatch, getState) => getIntlFromState(getState());
}

const query = `
  query ($locale:String!) {
    intl (locale:$locale) {
      id
      message
    }
  }
`;

export function setLocale({ locale }) {
  return async (dispatch, getState, { graphqlRequest }) => {
    dispatch({
      type: SET_LOCALE_START,
      payload: {
        locale,
      },
    });

    try {
      // WARNING !!
      // do not use client.networkInterface except you want skip Apollo store
      // use client.query if you want benefit from Apollo caching mechanisms

      let dynamicMessages = {};

      try {

        const localeData = formatLocaleData(locale)

        const response = await fetch(
          `/get-language?languageCode=${localeData}&appType=web`
        );

        const result = await response.json();

        if (result?.status === 200 && result?.data) {
          dynamicMessages = { ...result.data };
        }
      } catch (err) {
        console.log("Dynamic language load failed:", err);
      }

      dispatch({
        type: SET_LOCALE_SUCCESS,
        payload: {
          locale,
          messages: dynamicMessages
        },
      });

      await dispatch(getDynamicListSettings({ locale }));
      await dispatch(getDynamicListTitles({ locale }));

      // remember locale for every new request
      if (process.env.BROWSER) {
        const maxAge = 3650 * 24 * 3600; // 10 years in seconds
        document.cookie = `lang=${locale};path=/;max-age=${maxAge}`;
      }
      dateInternationalization(locale);
      return getIntlFromState(getState());
    } catch (error) {
      dispatch({
        type: SET_LOCALE_ERROR,
        payload: {
          locale,
          error,
        },
      });
      return false;
    }

    return true;
  };
}
